import Flickity from 'flickity';

export default {
  init($element) {

  },
  finalize($element) {
    const galleryCarousel = new Flickity($element.find('.gallery-carousel').get()[0], {
      prevNextButtons: false,
      pageDots: false,
      contain: true,
      cellAlign: 'left',
    });

    // Open photo info popup
    $element.find('.cell-attributes-btn').on('click', function() {
      const $popup = $(this).siblings('.cell-attributes-popup');
      $popup.toggleClass('show');
      $(this).toggleClass('show');
    });

    // Close photo info popup
    $(window).on('click', function(e) {
      if (e.target.classList[0] != 'cell-attributes-btn') {
        $element.find('.cell-attributes-popup').removeClass('show');
        $element.find('.cell-attributes-btn').removeClass('show');
      }
    });

    // Change slides
    $element.find('.gallery-navigation-prev').on('click', function() {
      galleryCarousel.previous();
    });

    $element.find('.gallery-navigation-next').on('click', function() {
      galleryCarousel.next();
    });

    galleryCarousel.on('change', function() {
      if (galleryCarousel.selectedIndex <= 0) {
        $element.find('.gallery-navigation-prev').addClass('inactive');
      } else {
        $element.find('.gallery-navigation-prev').removeClass('inactive');
      }

      if (galleryCarousel.selectedIndex + 1 >= galleryCarousel.slides.length) {
        $element.find('.gallery-navigation-next').addClass('inactive');
      } else {
        $element.find('.gallery-navigation-next').removeClass('inactive');
      }
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/shared/fullWidthGallery.js